// extracted by mini-css-extract-plugin
export default {"questionsModal":"questions_modal-module___questionsModal___cc7e2410","form":"questions_modal-module___form___d0472aac"};